import { Badge } from '@awazevr/design-system.components.badge'
import { StyledCalloutBadge } from './CalloutBadge.styles'

export type CalloutBadgeProps = {
  visible?: boolean
  text?: string
}

export const CalloutBadge = ({ visible = true, text }: CalloutBadgeProps) => {
  if (!visible || !text?.trim()) return null

  return (
    <StyledCalloutBadge>
      <Badge colourScheme="reverse" variant="solid" text={text} />
    </StyledCalloutBadge>
  )
}
